module.exports = __webpack_public_path__ + "img/Analytics_Computer.d86cd1ea.webp";